/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useMemo } from 'react';
import Input from 'antd/lib/input';
import { LuClock3 } from 'react-icons/lu';
import { useAppContext } from 'src/app/state';
import { ActionType } from 'src/app/state/action-type.enum';
import TimePopupContent from './TimePopupContent';
import { TimeOptions } from 'src/types/date-time.types';

type TimePickerProps = {
  selectedTime?: TimeOptions;
  handleSelectTime: (time: TimeOptions) => void;
};

const TimePicker = ({ selectedTime, handleSelectTime }: TimePickerProps) => {
  const {
    dispatch,
    state: { isPopUpOpened },
  } = useAppContext();

  const PopUpContent = useMemo(
    () => () => (
      <TimePopupContent
        selectedTime={selectedTime}
        handleSelectTime={handleSelectTime}
      />
    ),
    [selectedTime]
  );

  const setUpClock = useCallback(() => {
    dispatch({
      type: ActionType.SET_POP_UP_CONTENT,
      payload: {
        PopUpContent,
      },
    });
    dispatch({
      type: ActionType.SET_POP_UP_HEADER,
      payload: { popUpHeader: 'Select time' },
    });
    dispatch({
      type: ActionType.SET_POP_UP_FOOTER,
      payload: {
        PopUpFooter: undefined,
      },
    });
  }, [PopUpContent]);

  const handleClockOpen = () => {
    setUpClock();
    dispatch({ type: ActionType.POP_UP_OPEN, payload: {} });
  };

  return (
    <div>
      <Input
        size='large'
        placeholder='Select time'
        value={
          selectedTime
            ? `${selectedTime.hours}:${selectedTime.minutes} ${selectedTime.period}`
            : ''
        }
        onClick={handleClockOpen}
        disabled={isPopUpOpened}
        suffix={<LuClock3 onClick={handleClockOpen} />}
      />
    </div>
  );
};

export default TimePicker;
